import Vue from 'vue'
import jquery from 'jquery'
import eventHub from './../bankrate-events'
import tagularBeam from 'js/services/tagularEvent'
import tagularModule from 'js/store/helpers/tagular'
import { isAuthenticated } from 'js/bankrate-utilities'

let mixin = {
  data: function() {
    return {
      emailElm: null,
      buttonElm: null,
      email: null,
      formElm: null,
      error: null,
      success: null
    }
  },
  mounted: function() {
    this.setData()
    eventHub.$once('signup.complete', this.showSuccess)
  },
  methods: {
    setData: function setData() {
      this.formElm = this.$el
      this.emailElm = this.$el.querySelector('[name="email"]')
      this.buttonElm = this.$el.querySelector('button')
    },
    signUp: function signUp(event) {
      event.preventDefault()
      this.email = this.emailElm.value

      if (this.validateEmail(this.email)) {
        this.hideError()
        this.sendRequest()
      } else {
        this.error = 'Enter a valid e-mail address'
        this.showError()
      }
    },
    validateEmail: function validateEmail(email) {
      return /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i.test(
        email
      )
    },
    showError: function showError() {
      if (!/--error/.test(this.formElm.className)) {
        this.formElm.className += ' --error'
        this.emailElm.className += ' --error'
        this.emailElm.className = this.emailElm.className.replace(
          ' --typing',
          ''
        )
        this.emailElm.value = this.error
        this.buttonElm.className += ' --error'
      }
    },
    hideError: function hideError() {
      if (/--error/.test(this.formElm.className)) {
        this.formElm.className = this.formElm.className.replace(' --error', '')
        this.emailElm.className = this.emailElm.className.replace(
          ' --error',
          ''
        )
        this.buttonElm.className = this.buttonElm.className.replace(
          ' --error',
          ''
        )
      }
    },
    applyTypingBehavior: function applyTypingBehavior(event) {
      if (!/--typing/.test(event.target.className)) {
        event.target.className += ' --typing'
        this.hideError()
      }
    },
    clear: function clear(event) {
      this.hideError()
      event.target.value = ''
    },
    showSuccess: function showSuccess(msg) {
      this.hideError()
      this.emailElm.value = msg || this.success
      this.emailElm.disabled = true
      this.buttonElm.style.display = 'none'
    },
    sendRequest: function sendRequest() {
      var elements = jquery(this.formElm).serialize()

      jquery.ajax({
        type: 'POST',
        url: jquery(this.formElm).attr('action'),
        data: elements,
        success: function(response) {
          if (response.status === 'ERROR') {
            this.error = response.message

            console.error('Newsletter sign up: ' + response.status_code)

            this.showError()

            return false
          }

          if (response.status_code === 'success_sign_up') {
            const tagularPayload = {
              formName: 'Email_Capture_Daily',
              formType: 'AUTHENTICATION',
              formID: tagularModule.generateUniqueId(),
              stepName: isAuthenticated()
                ? 'Verify_Identity_Emailaddition'
                : 'Verify_Identity_Emailonly',
              stepType: 'CONFIRMATION',
              stepID: tagularModule.generateUniqueId()
            }

            tagularBeam(
              'formOutcomeReceived',
              tagularPayload,
              'authenticated',
              'v1alpha1'
            )
            this.success = response.message
            eventHub.$emit('signup.complete', this.success)
          }
        }.bind(this),
        error: function() {
          this.error = 'A problem occurred, please try again later.'
          this.showError()
        }.bind(this)
      })
    }
  }
}

var vueInstance = []
var elms = [].slice.call(document.querySelectorAll('[data-newsletter-signup]'))

elms.forEach(function(el) {
  vueInstance.push(
    new Vue({
      el: el,
      mixins: [mixin]
    })
  )
})
